import { RefElement } from 'widgets/toolbox/RefElement';
import { TWidget } from 'widgets/Widget';
import { extractPath } from '../utils';

/**
 * @description FooterTrack implementation
 * @param Widget Base widget for extending
 * @returns FooterTrack class
 */
function FooterTrackClassCreator(Widget: TWidget) {
    class FooterTrack extends Widget {
        prefs() {
            return {
                parentNameClass: 'b-footer_nav-heading',
                socialNameClass: 'b-footer_headline-title',
                ...super.prefs()
            };
        }

        /**
         * @description Track click on footer menu links
         */
        menuFooterClick(menuItem: RefElement<HTMLElement>) {
            const url = extractPath(menuItem.attr('href'));
            const parentNameElement = this.ref('self').get()?.getElementsByClassName(this.prefs().parentNameClass)?.[0];
            const parentName = parentNameElement?.textContent ? parentNameElement.textContent.replace(/\n/g, ' ').trim() : '';

            this.eventBus().emit('footer.click', url, parentName);
        }

        /**
         * @description Track click on footer menu links
         */
        socialFooterClick(menuItem: RefElement<HTMLElement>) {
            const url = menuItem.attr('href');
            const parentNameElement = this.ref('self').get()?.getElementsByClassName(this.prefs().socialNameClass)?.[0];
            const parentName = parentNameElement?.textContent ? parentNameElement.textContent.replace(/\n/g, ' ').trim() : '';

            this.eventBus().emit('footer.click', url, parentName);
        }
    }

    return FooterTrack;
}

export type TFooterTrack = ReturnType<typeof FooterTrackClassCreator>;

export type TFooterTrackInstance = InstanceType<TFooterTrack>;

export default FooterTrackClassCreator;
